import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, shareReplay, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

import { SettingsFormBuilderService } from '@main-client/src/app/settings/settings-form-builder.service';

import { Tenant } from '@libs/src/tenant/tenant.interface';
import { IAppState } from '@main-client/src/app/app.state';

import isEmpty from 'lodash-es/isEmpty';
import merge from 'lodash-es/merge';

@Component({
  selector: 'app-settings-personal',
  templateUrl: './settings-personal.component.html',
})
export class SettingsPersonalComponent implements OnInit, OnDestroy {
  componentDestroy = new Subject<void>();
  isLoading: boolean;
  settingsView: any[] = [];
  tenant: Tenant;
  tenant$ = this.store.select('tenant');
  user$ = this.store.select('user').pipe(shareReplay(1));

  constructor(
    private store: Store<IAppState>,
    private settingsFormBuilderService: SettingsFormBuilderService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    combineLatest([this.tenant$, this.user$])
      .pipe(
        filter(([tenant, user]) => !isEmpty(tenant) && !isEmpty(user)),
        tap(([tenant, user]) => {
          const update =
            this.settingsFormBuilderService.generatePersonalSettings(
              tenant,
              user,
            );
          this.settingsView = merge(this.settingsView, update);
          this.isLoading = false;
          this.tenant = tenant;
        }),
        takeUntil(this.componentDestroy),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.componentDestroy.next();
    this.componentDestroy.complete();
  }
}
